import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import AppointmentEditForm, { prepareAppointmentForEdit, prepareEditDataForApi } from "./AppointmentEditForm"; 

const API_BASE_URL = "https://api.muktihospital.com/api";
const API_KEY = "caf56e69405fe970f918e99ce86a80fbf0a7d728cca687e8a433b817411a6079";

const AppointmentEditModal = ({ isOpen, onClose, appointmentId, onSaveSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    if (isOpen && appointmentId) {
      const fetchAppointment = async () => {
        setLoading(true);
        try {
          const res = await axios.get(`${API_BASE_URL}/appointment/${appointmentId}`, {
            headers: { "x-api-key": API_KEY },
          });
          setEditData(prepareAppointmentForEdit(res.data.appointment));
        } catch (error) {
          console.error("Error fetching appointment:", error);
          toast.error("Failed to load appointment details.");
          onClose();
        } finally {
          setLoading(false);
        }
      };
      fetchAppointment();
    }
  }, [isOpen, appointmentId]);

  // 2. Handle changes inside the form fields
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  // 3. Handle Save Button click
  const handleSaveEdit = async () => {
    try {
      const payload = prepareEditDataForApi(editData);
      
      await axios.put(`${API_BASE_URL}/appointment/edit/${appointmentId}`, payload, {
        headers: { "x-api-key": API_KEY },
      });

      toast.success("Appointment updated successfully!");
      if (onSaveSuccess) onSaveSuccess();
      onClose();
    } catch (error) {
      console.error("Error updating appointment:", error);
      toast.error("Failed to update appointment.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-[#f5f9fd] shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg relative">
        {/* Modal Body */}
        <div className="p-4">
          {loading ? (
            <div className="flex justify-center items-center h-40">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
            </div>
          ) : editData ? (
            <AppointmentEditForm
              editData={editData}
              handleEditChange={handleEditChange}
              handleSaveEdit={handleSaveEdit}
              editMode={appointmentId}
              onCancel={onClose}
            />
          ) : (
            <div className="text-center py-10 text-red-500">No data found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentEditModal;